if (!customElements.get('fundraising-bar')) {
  class FundraisingBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.animateProgress();
    }

    animateProgress() {
      const progressFill = this.querySelector('[data-progress]');
      
      if (!progressFill) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              progressFill.classList.add('animated');
            }, 200);
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1
      });

      observer.observe(this);
    }
  }

  customElements.define('fundraising-bar', FundraisingBar);
}